import React from 'react';
import EnquirySliderLogin from '../components/EnquirySliderLogin';
import EnquirySliderSignUp from '../components/EnquirySliderSignUp';
import RegistrationOfInterestForm from '../components/RegistrationOfInterestForm';
import { Score } from 'models/DealRoom';
import { ObjectValues } from 'types';

export type EnquiryQuestionType = {
  title: string;
  answer: string;
  score: Score;
};

export type EnquiryFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  context?: string;
  questions?: EnquiryQuestionType[];
};

export type EnquiryRoutes = ObjectValues<typeof ENQUIRY_ROUTES>;

export const ENQUIRY_ROUTES = {
  LOGIN: 'login',
  SIGN_UP: 'sign-up',
  REGISTRATION_OF_INTEREST_FORM: 'registration-of-interest-form',
} as const;

export const ENQUIRY_CONTENT: Record<EnquiryRoutes, React.FC> = {
  login: EnquirySliderLogin,
  'sign-up': EnquirySliderSignUp,
  'registration-of-interest-form': RegistrationOfInterestForm,
};
